import React from 'react';
import { Typography, Box } from '@mui/material';

const TCT = () => {
  return (
    <Box>
      <Typography variant="h5">TCT Form</Typography>
    </Box>
  );
};

export default TCT;
